import api from "./api";
import { IAtleta, IAtletaResponse } from "interfaces/atleta";
import { SEXO_VALUES } from "helpers/constants";
import { numbersOnly } from "helpers/utils";

/**
 * Listar todos os Atletas
 */
export async function getAllAtleta(
  page: number = 1,
  limit: number = 10
): Promise<{ data: IAtletaResponse; status: number }> {
  try {
    const { data, status } = await api.get(
      `/atleta?page=${page}&limit=${limit}`
    );
    return { data, status };
  } catch (error) {
    throw new Error("Falha na comunicação com o servidor");
  }
}

/**
 * SEARCH: Buscar Atletas pelo nome, cpf e email
 */
export async function searchAtleta(
  search: string
): Promise<{ data: IAtleta[]; status: number }> {
  try {
    const term = search.trim();
    const { data, status } = await api.get(
      `/atleta/${encodeURIComponent(term)}`
    );
    return { data, status };
  } catch (error) {
    throw new Error("Falha na comunicação com o servidor");
  }
}

/**
 * Excluir uma Atletas
 */
export async function deleteAtleta(id: number) {
  try {
    return await api.delete(`/atleta/${id}`);
  } catch (error) {
    throw new Error("Falha na comunicação com o servidor");
  }
}

// Atualizar os dados do Atleta
export async function updateAtleta(atleta: any) {
  try {
    const dataAtleta = {
      ...atleta,
      cpf: numbersOnly(atleta.cpf),
      celPhone: numbersOnly(atleta.celPhone),
      telefone: numbersOnly(atleta.telefone),
      celPhoneEmergencia: numbersOnly(atleta.celPhoneEmergencia),
      sexoId: SEXO_VALUES[atleta.sexo as keyof typeof SEXO_VALUES],
      logradouro: atleta.endereco,
    };

    const { data, status } = await api.put("/atleta", dataAtleta);

    return { data, status };
  } catch (error) {
    throw new Error("Erro comunicação com o servidor");
  }
}
